import type {
  SaleChannel,
  SalePaymentMethod,
  SalePaymentStatus,
} from "@artisancode/api-types";

export const SALE_CHANNEL_LABELS: Record<SaleChannel, string> = {
  office: "Kantor",
  rider: "Rider",
  app: "Aplikasi",
  event: "Event",
  other: "Lainnya",
};

export const SALE_PAYMENT_STATUS_LABELS: Record<SalePaymentStatus, string> = {
  paid: "Lunas",
  unpaid: "Belum Bayar",
  partial: "Sebagian",
  cancelled: "Batal",
};

export const SALE_PAYMENT_METHOD_LABELS: Record<SalePaymentMethod, string> = {
  cash: "Tunai",
  edc: "EDC",
  qris: "QRIS",
  app_qris: "App QRIS",
  bank_transfer: "Transfer",
  credit_unpaid: "Kasbon/Belum Bayar",
};
